@if (!team) {
  <p>Loading</p>
}
@if (team) {
  <div class="team-container">
    <h3>
      To change team assignments, please use the
      <button
        mat-flat-button
        color="accent"
        routerLink="/setup/resourcing/resources"
        >
        Resource Admin
      </button>
      or
      <button
        mat-flat-button
        color="accent"
        routerLink="/setup/resourcing/planners"
        >
        Planner Admin
      </button>
      screens.
    </h3>
    <div class="team-assignment-container">
      <div class="assignment-fill">
        <h2>Assigned Resources</h2>
        <app-grid [data]="resourceList" [columns]="resourceColumns" [filter]="true" [autoHeight]="true" [cellEdit]="false" [readOnly]="true"></app-grid>
      </div>
      <div class="assignment-fill">
        <h2>Assigned Planners</h2>
        <app-grid [data]="plannerList" [columns]="plannerColumns" [filter]="true" [autoHeight]="true" [cellEdit]="false" [readOnly]="true"></app-grid>
      </div>
    </div>
  </div>
}
